<template>
  <div>
    <layout-founders-base :board="board">
      <layout-founder-board :board="board" class="founder-board">
        <template #default>
          <div
            v-if="canEdit"
            class="edit-ui padding gap-s padding-l-inline-end bg-lead c-bg absolute flex-middle flex-center z-level-2"
            style="">
            <quick-edit
              class="margin-remove"
              tooltip="ls.founderBoard.quickEditBoardCta"
              :editor="founderBoardEditor"
              halo-theme="bg"
              theme="lead"
              position="inline"
              :position-offset="0"
              :size="2"
              :fields="'all'"></quick-edit>
            <icon-halo
              v-if="canEdit"
              v-tooltip="{ content: 'ls.founderBoard.quickAddToBoardCta' }"
              class="cursor-pointer"
              halo-theme="success"
              theme="bg"
              icon="plus"
              :size="2"
              style=""
              @click="startCreatingFounder"></icon-halo>

            <icon-halo
              v-if="canEdit && ! board?.randomizeFounderOrder &&  board.founderOrder === 'order'"
              v-tooltip="{ content: 'ls.founderBoard.quickAddToBoardCta' }"
              class="cursor-pointer"
              halo-theme="gray-5"
              theme="bg"
              icon="arrows-sort"
              :size="2"
              style=""
              @click="showSortModal = true"></icon-halo>
          </div>
          <div
            v-if="board?.Founders[0]"
            id="founders-board-index"
            class="flex flex-wrap gap-xl flex-stretch flex-center">
            <!-- specific sizing is related to size of board on full HD -->
            <a
              v-for="founder in board?.Founders"
              :key="founder.id"
              :href="getFounderLink(founder)"
              class="founder-intro-link"

              @click.prevent="showFounder(founder)"
            >
              <founder-intro
                :ref="`founder-intro-${founder.id}`"
                :size="board.cardSize"
                class="founder-intro cursor-pointer"
                :style="founderIntroDynamicStyle"
                :founder="founder"
                @click="showFounder(founder)"></founder-intro>
            </a>

          </div>
          <h2 v-else>{{ translate("ls.foundersView.noFoundersFound") }}</h2>

          <modal
            v-if="shouldShowFounderModal"
            :show="shouldShowFounderModal"
            ref="founderModal"
            :tight="true"
            size="2xl"
            class="modal modal--lead founder-full-modal"
            :show-header="false"
            :show-footer="false"
            @modal:closed="currentFounder = false">
            <template #default>
              <div
                class="founder-modal-content relative bg-inverse c-bg padding-xl"
                style="overflow: hidden; height: calc(95vh)">
                <div
                  class="founder-modal-timer-container flex-center flex-middle gap-m"
                  v-if="board.autoCloseModals">
                  <icon-halo
                    v-if="!canEdit"
                    class="cursor-pointer"
                    halo-theme="lead"
                    theme="bg"
                    icon="go-forward"
                    @click="resetAutoCloseTimer()" />
                  <span v-if="!canEdit">
                    <span
                    >{{ tu("ls.founderBoard.closeTimerExplain") }}&nbsp;</span
                    >
                    <span class="ltr"></span>
                    <span>{{ minutesUntilClosedForDisplay }}</span>
                    <span>:</span>
                    <span>{{ secondsUntilClosedForDisplay }}</span>
                  </span>
                  <span v-if="canEdit">{{
                      t("ls.founderBoard.adminTimerText")
                    }}</span>
                </div>

                <div
                  class="founder-container overflow-y-auto overflow-x-hidden"
                  style="height: 100%; max-height: 100%">
                  <founder-full
                    v-if="shouldShowFounderModal"
                    :founder-board="board"
                    bg-theme="inverse"
                    theme="bg"
                    :founder="currentFounder"
                    @founder:startedShowingVideo="stopTimer()"
                    @founder:stoppedShowingVideo="activateTimer()"
                    @founder:edited="handleFounderUpdated"
                    @founder:mediaEdited="handleFounderMediaUpdated"
                    @founder:deleted="handleFounderDeleted"></founder-full>
                </div>
              </div>
            </template>
          </modal>
          <quick-editor
            v-bind="founderBoardEditor.editorComponentConfig"></quick-editor>

          <modal
            :show="isCreatingFounder"
            title="ls.founder.feCreateTitle"
            :show-footer="false"
            @modal:closed="stopCreatingFounder">
            <base-form
              ref="founderForm"
              v-model="newFounderData"
              action="founder"
              method="post"
              form-path="entity/founder/create"
              :config="{
                fields: {
                  OwnerId: { type: 'hidden' },
                  youtubeVideos: { type: 'hidden' },
                },
              }"
              @form:submit-success="founderCreatedHandler"></base-form>
          </modal>

          <item-orderer
            :as-modal="true"
            v-model:isOpen="showSortModal"
            v-if="board.Founders && board?.Founders?.length > 1"
            :items="board.Founders"
            modal-title="ls.founderBoard.sortUi.modalTitle"
            endpoint="entity/Founder/setOrdering"
            :immediate-reorder="false"
            @itemOrderer:success="handleReorder">
            <!--
            v-model="board.Founders"

            -->


            <template #item="{item}">
              <div class="flex-middle gap-m" style="min-width: 0;">

                <img
                  class="border-radius-s bg-gray-1 padding-xs"
                  style="
               height: calc(var(--base-margin) * 60);
               width: calc(var(--base-margin) * 60);
               object-fit: contain;
               object-position: center;
             "
                  v-if="getFounderImage(item)"
                  :src="getFounderImage(item)" />

                <div v-else class="bg-lead-1 border-thin-lead-2 border-radius padding-s flex-middle flex-center" style="
               height: calc(var(--base-margin) * 60);
               width: calc(var(--base-margin) * 60);
               object-fit: contain;
               object-position: center;
             ">
                  <icon icon="user" :size="4" />
                </div>

                <span class="text-overflow-ellipsis">{{
                    item.fullName + "test"
                  }}</span>
              </div>
            </template>
          </item-orderer>
        </template>
        <template #sidebar>
          <div class="sidebar-inner">
            <div class="search">
              <div class="search-ui flex" style="overflow: hidden">
                <form-input
                  v-model="searchText"
                  class="search-input"
                  icon="magnify"
                  @keyup.enter="doSearch"></form-input>
                <form-button
                  text="ls.founderBoard.searchCta"
                  @click="doSearch"></form-button>
              </div>
            </div>
            <div
              class="search-results-container relative padding-l-vertical"
              style="overflow-y: auto; flex: 100%; height: 100%">
              <span
                class="block text-center underline c-text cursor-pointer"
                v-if="board && searchResults"
                @click="searchResults = false">
                {{ t("ls.founderBoard.clearSearch") }}
              </span>
              <div class="results-container" style="">
                <div
                  v-if="isSearchLoading"
                  class="spinner-container flex flex-middle flex-center margin-2xl-vertical">
                  <spinner :size="3" class="margin-auto-horizontal" />
                </div>

                <founder-micro
                  v-for="founder in searchResults"
                  v-if="board && searchResults"
                  class="margin-l-top margin-xl-bottom cursor-pointer"
                  style="width: 100%"
                  :founder="founder"
                  @click="showFounder(founder)"></founder-micro>
                <h3
                  v-if="
                    searchResults &&
                    (searchResults.length === 0 || !searchResults.length)
                  ">
                  {{ tu("ls.founderBoard.search.noResults") }}
                </h3>
              </div>
            </div>
            <div v-if="board.mainImageUrl" class="illustration">
              <img
                class="object-contain max-size-parent"
                :src="board.mainImageUrl"
                alt="" />
            </div>
          </div>
        </template>
      </layout-founder-board>
    </layout-founders-base>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import useDom from "@/client/extensions/composition/useDom";
import { computed, inject, ref, watchEffect } from "vue";
import FounderIntro from "@/client/applications/localstory/components/founders/founder/FounderIntro";
import FounderMicro from "@/client/applications/localstory/components/founders/founder/FounderMicro";
import FounderFull from "@/client/applications/localstory/components/founders/founder/FounderFull";
import useQuickEdit from "@/client/extensions/composition/useQuickEdit";
import { useStore } from "vuex";
import ItemOrderer from "@/client/applications/localstory/components/edit/ItemOrderer.vue";

export default {
  props: {
    founderBoardAlias: {
      type: String,
      default: "",
    },
    activeFounderId: {
      type: [Number, Boolean],
      default: false,
    },
  },

  // handle default meta
  meta: {
    title: "ls.founderBoard.metaTitleLoading",
  },

  components: {
    ItemOrderer,
    FounderIntro,
    FounderMicro,
    FounderFull,
  },

  setup(props) {
    let { secondsSinceLastActivity, isLargerThanL, isLargerThanXl } = useDom();

    let store = useStore();
    let { asyncOps, asyncOpsReady } = asyncOperations(props);
    let canEdit = ref(false);

    let endpoint = ref(`entity/founderBoard/0`);
    let setQuickUpdateEndpoint = (str) => {
      endpoint.value = str;
    };

    let { editor: founderBoardEditor } = useQuickEdit({
      target: "board",
      form: "founderBoard",
      enabled: false,
      formData: { userProfile: store },
      editorProps: {
        modalSize: "l",
      },
      callback: (arg, instance) => {
        return true;
      },
      endpoint: endpoint,
    });

    watchEffect(() => {
      let profile = store.getters["user/profile"];
      if (!profile) {
        canEdit.value = false;
        return founderBoardEditor.disable();
      }
      let ownsBoard = profile?.FounderBoard?.alias == props?.founderBoardAlias;
      if (profile?.isSuperAdmin || ownsBoard) {
        canEdit.value = true;
        return founderBoardEditor.enable();
      }
      canEdit.value = false;
      founderBoardEditor.disable();
    });

    let meta = inject("meta");
    return {
      asyncOps,
      asyncOpsReady,
      founderBoardEditor,
      canEdit,
      setQuickUpdateEndpoint,
      secondsSinceLastActivity,
      isLargerThanXl,
      isLargerThanL,
      meta,
    };
  },

  data: function() {
    return {
      autoResetIntervalSeconds: config.founderBoard.autoResetIntervalSeconds,
      newFounderData: {},
      isCreatingFounder: false,
      defaultCloseTime: 60 * 10,
      timerInterval: null,
      currentFounder: false,
      searchResults: false,
      isSearchLoading: false,
      secondsToClose: 635,
      searchText: "",
      fetchError: false,
      ignoreNewBoardWatch: false,
      hasSearched: false,
      shouldShowFounderModal: false,
      showSortModal: false,
      board: false,
      asyncData: {
        board: {
          target: computed(() => `founder-board/${this.founderBoardAlias}`),
          data: {
            ordering: {
              key: "fullName",
              direction: "asc",
            },
          },
          options: {
            dataMutator: (data) => {
              if (!data || !data.item) {
                this.fetchError = true;
                return false;
              }

              return data.item;
            },
            errorHandler: 404,
          },
        },
      },
    };
  },
  computed: {
    minutesUntilClosed() {
      if (!this.secondsToClose || this.secondsToClose === 0) {
        return 0;
      }

      return Math.floor(this.secondsToClose / 60);
    },
    secondsUntilClosed() {
      if (!this.secondsToClose || this.secondsToClose === 0) {
        return 0;
      }

      return Math.floor(this.secondsToClose % 60);
    },
    minutesUntilClosedForDisplay() {
      if (!this.secondsToClose || this.secondsToClose === 0) {
        return 0;
      }

      return String(this.minutesUntilClosed).padStart(2, "0");
    },
    secondsUntilClosedForDisplay() {
      if (!this.secondsToClose || this.secondsToClose === 0) {
        return 0;
      }

      return String(this.secondsUntilClosed).padStart(2, "0");
    },
    hasFounderIntroBg() {
      return (
        this?.board?.introBorderImage && this?.board?.introBorderImage != ""
      );
    },
    founderIntroBorderImageDynamicStyle() {
      if (this.hasFounderIntroBg && this.board.cardSize === "s") {
        if (this.isLargerThanXl) {
          return {
            "border-image": `url('${this.founderBg}') 50 fill / calc(var(--base-margin) * 55) / calc(var(--base-margin) * 17) `,
            "border-radius": "calc(var(--base-margin) * 8)",
          };
        }

        if (this.isLargerThanL) {
          return {
            "border-image": `url('${this.founderBg}') 50 fill / calc(var(--base-margin) * 55) / calc(var(--base-margin) * 17) `,
            "border-radius": "calc(var(--base-margin) * 8)",
          };
        }

        return {
          "border-image": `url('${this.founderBg}') 42 fill / calc(var(--base-margin) * 50) / calc(var(--base-margin) * 17) `,
        };
      }
      if (this.hasFounderIntroBg && this.board.cardSize === "l") {
        if (this.isLargerThanXl) {
          return {
            "border-image": `url('${this.founderBg}') 50 fill / calc(var(--base-margin) * 35) / calc(var(--base-margin) * 12) `,
            "border-radius": "calc(var(--base-margin) * 8)",
          };
        }

        if (this.isLargerThanL) {
          return {
            "border-image": `url('${this.founderBg}') 50 fill / calc(var(--base-margin) * 55) / calc(var(--base-margin) * 17) `,
            "border-radius": "calc(var(--base-margin) * 8)",
          };
        }

        return {
          "border-image": `url('${this.founderBg}') 42 fill / calc(var(--base-margin) * 35) / calc(var(--base-margin) * 12) `,
        };
      }

      return {
        "box-shadow": "var(--box-shadow-1)",
        "border-radius": "var(--border-radius-l)",
      };
    },
    founderIntroSizeDynamicStyle() {
      let sizes = {
        s: {
          flex: "0 0 calc(var(--base-margin) * 180)",
          "max-width": "calc(var(--base-margin) * 155)",
          "min-height": "calc(var(--base-margin) * 75)",
        },
        l: {
          flex: "0 0 calc(var(--base-margin) * 254)",
          "max-width": "calc(var(--base-margin) * 300)",
          "min-height": "calc(var(--base-margin) * 240)",
        },
      };

      return sizes[this?.board?.cardSize ? this?.board?.cardSize : "s"];
    },
    founderIntroDynamicStyle() {
      return {
        ...this.founderIntroBorderImageDynamicStyle,
        ...this.founderIntroSizeDynamicStyle,
      };
    },
    founderBg() {
      if (this.hasFounderIntroBg) {
        return this.board.introBorderImage;
      }
      return false;
    },
  },
  watch: {
    secondsSinceLastActivity(newVal) {
      if (newVal != 0 && newVal % this.autoResetIntervalSeconds === 0) {
        this.resetDisplay();
      }
    },
    board: {
      handler(newVal) {
        if (this.ignoreNewBoardWatch) {
          return true;
        }

        if (!newVal) {
          return;
        }

        this.setQuickUpdateEndpoint(`entity/founderBoard/${newVal.id}`);

        if (!newVal.Founders) {
          return;
        }

        this.$nextTick(() => {
          this.randomizeFounderOrderIfApplicable();
        });

        this.newFounderData.FounderBoardId = newVal.id;

        this.clearSearch();

        if (this.activeFounderId) {
          let founder = this.getBoardFounderById(this.activeFounderId);
          if (founder) {
            this.showFounder(founder, true);
          }
        }
      },
      deep: true,
    },
    secondsToClose(newVal) {
      if (newVal === 0) {
        this.stopShowingFounder();
      }
    },
    currentFounder(newVal) {
      if (newVal !== false) {
        this.shouldShowFounderModal = true;
      } else {
        this.shouldShowFounderModal = false;
        const newPath = this.$router.resolve({
          name: "founders-founderBoardAlias",
          params: {
            founderBoardAlias: this.board.founderBoardAlias,
          },
        }).href;
        window.history.replaceState({}, "", newPath);
      }

      this.updateMetaByState();
    },
  },
  methods: {
    setMetaByCurrentFounder(founder) {
      if (!founder) {
        founder = this.currentFounder;
      }

      /**
       * Try to extract a reasonably long description from the founder content
       * @param founder
       * @returns {undefined|*}
       */
      let getFounderDescription = (founder) => {
        try {
          if (founder?.description?.blocks?.[0]?.data?.text) {
            return utilities.truncate(
              founder?.description?.blocks?.[0]?.data?.text,
              120,
              true,
            ).replaceAll(`"`, `''`);
          }
        } catch (e) {
        }

        return founder.fullName;
      };
      /**
       * Get some image for the founder meta. Priorty: featured image, first image, video image from youtube
       * @param founder
       * @returns {*|null}
       */
      let getFounderImage = (founder) => {
        let firstImage = null;
        let videoImage = null;
        let featuredImage = null;
        if (founder.FounderMedia) {
          founder.FounderMedia.forEach((item) => {
            if (!firstImage) {
              firstImage = item.Media.url;
            }
            if (item.featured) {
              featuredImage = item.Media.url;
            }

            return false;
          });
        }

        if (featuredImage) {
          return featuredImage;
        }

        if (firstImage) {
          return firstImage;
        }

        // no images, extract from videos
        if (founder?.youtubeVideos && Array.isArray(founder?.youtubeVideos)) {
          founder.youtubeVideos.forEach((item) => {
            if (item.youtubeId && item.youtubeId !== "") {
              videoImage = `https://img.youtube.com/vi/${item.youtubeId}/default.jpg`;
              return false;
            }
          });
        }

        return videoImage;
      };

      let title = `${this.board.name} | ${founder.fullName}`;
      let meta = {
        title: title.replaceAll(`"`, `''`),
        metaTitle: title.replaceAll(`"`, `''`),
        description: getFounderDescription(founder),
        ogImage: getFounderImage(founder),
      };
      this.setMetaByMetaObject(meta);
    },
    updateMetaByState() {
      if (this?.board?.meta && typeof this.board.meta === "object") {
        this.setMetaByMetaObject(this.board.meta);

        if (this.activeFounderId) {
          let founder = this.getBoardFounderById(this.activeFounderId);

          this.setMetaByCurrentFounder(founder);
        }
        return true;
      }

      if (!this.board) {
        return;
      }
      let hasMetaObject =
        !this.board.meta || typeof this.board.meta === "object";

      // soft check if there is NO meta object
      if (!hasMetaObject || !this.board.meta || this.board.meta === "") {
        this.meta.title = this.translate("ls.founderBoard.metaTitle", {
          name: this.board.name,
        });
      }
    },
    resetDisplay() {
      let foundersBackup = [...this.board.Founders];
      this.board.Founders = [];
      this.$nextTick(() => {
        this.board.Founders = foundersBackup;
      });
      this.clearSearch();
    },
    randomizeFounderOrder() {
      const shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
      };
      if (!this.board.Founders || this.board.Founders.length < 2) {
        return true;
      }
      // as we will change the array, we need to stop the watcher - or ther ewill be infinite loop
      this.ignoreNewBoardWatch = true;
      this.board.Founders = shuffleArray(this.board.Founders);
      this.$nextTick(() => {
        this.ignoreNewBoardWatch = false;
      });
    },
    randomizeFounderOrderIfApplicable() {
      if (this.board.randomizeFounderOrder) {
        this.randomizeFounderOrder();
        return true;
      }

      return false;
    },
    activateTimer() {
      clearInterval(this.timerInterval);
      if (!this.board.autoCloseModals) {
        return false;
      }
      this.timerInterval = setInterval(() => {
        if (this.secondsToClose === 0) {
          clearInterval(this.timerInterval);
          return;
        }
        this.secondsToClose = this.secondsToClose - 1;
      }, 1000);
      return true;
    },
    stopTimer() {
      clearInterval(this.timerInterval);
    },
    resetAutoCloseTimer() {
      this.secondsToClose = this.defaultCloseTime;
      this.activateTimer();
    },
    clearSearch() {
      this.searchResults = false;
      this.searchText = "";
      this.hasSearched = false;
    },
    clearSearchResults() {
      this.searchResults = false;
    },
    async doSearch() {
      if (this.searchText == "") {
        return true;
      }

      let searchData = {
        founderBoardId: this.board.id,
        searchQuery: this.searchText,
      };

      let res = await this.asyncOps.asyncCall(
        "founder/search/fuzzy",
        searchData,
      );

      if (res.hasError) {
        this.$s.ui.notification("core.genericError", "error");
        return;
      }

      this.searchResults = res.data.items;
      this.searchText = "";
      this.hasSearched = true;
    },
    getFounderLink(founder) {
      return this.$router.resolve({
        name: "founders-founderBoardAlias-founderId",
        params: {
          founderBoardAlias: this.board.founderBoardAlias,
          founderId: founder.id,
        },
      }).href;        // absolute path that goes straight into <a href="">
    },

    showFounder(founder, immediate = false) {
      // if we are "live" activating a founder
      if (!utilities.isSSR()) {
        if (parseInt(this.activeFounderId) !== parseInt(founder.id)) {
          const newPath = this.$router.resolve({
            name: "founders-founderBoardAlias-founderId",
            params: {
              founderBoardAlias: this.board.founderBoardAlias,
              founderId: founder.id,
            },
          }).href;
          window.history.replaceState({}, "", newPath);
        }


      }

      let doShowFounder = () => {
        this.currentFounder = founder;
        if (!this.canEdit) {
          this.resetAutoCloseTimer();
        }
      };

      if (immediate) {
        doShowFounder();
      } else {
        this.$nextTick(doShowFounder);
      }
    },
    getBoardFounderById(id) {
      let result = false;
      this.board.Founders.forEach((founder) => {
        if (parseInt(founder.id) === parseInt(id)) {
          result = founder;
          return false;
        }
      });
      return result;
    },
    stopShowingFounder() {
      this.currentFounder = false;
      this.$refs["founderModal"].closeModal();
      this.stopTimer();
    },
    founderCreatedHandler(res) {
      this.$s.ui.notification("core.successGeneric", "success");
      this.stopCreatingFounder();
      this.resetFounderCreateData();
      this.refreshAsyncData();
    },
    resetFounderCreateData() {
      this.newFounderData = { FounderBoardId: this?.board.id };
    },
    stopCreatingFounder() {
      this.isCreatingFounder = false;
    },
    startCreatingFounder() {
      this.isCreatingFounder = true;
    },
    async handleFounderMediaUpdated() {
      let currentFounderId = this?.currentFounder?.id;
      if (!currentFounderId) {
        return;
      }

      let newFounderResult = await this.asyncOps.asyncCall(
        `founder/${currentFounderId}`,
      );
      if (newFounderResult.hasError) {
        this.$s.ui.notification("ls.founder.editSuccessfulButFailedUiUpdate");
        return true;
      }

      try {
        this.board.Founders.forEach((item, index) => {
          if (item.id === currentFounderId) {
            this.currentFounder = newFounderResult.data.item;
            this.board.Founders[index] = newFounderResult.data.item;
          }
        });
      } catch (e) {
      }
    },
    async handleFounderUpdated() {
      let currentFounderId = this?.currentFounder?.id;
      if (!currentFounderId) {
        return;
      }

      let newFounderResult = await this.asyncOps.asyncCall(
        `founder/${currentFounderId}`,
      );
      if (newFounderResult.hasError) {
        this.$s.ui.notification("ls.founder.editSuccessfulButFailedUiUpdate");
        return true;
      }

      try {
        this.board.Founders.forEach((item, index) => {
          if (item.id === currentFounderId) {
            this.currentFounder = newFounderResult.data.item;
            this.board.Founders[index] = newFounderResult.data.item;
          }
        });
      } catch (e) {
      }
    },
    async handleFounderDeleted() {
      this.refreshAsyncData();
      this.stopShowingFounder();
      this.currentFounder = false;
      this.searchResults = false;
      this.searchText = "";
    },
    handleReorder(data) {
      this.refreshAsyncData();
      this.currentFounder = false;
      this.searchResults = false;
      this.searchText = "";

    },
    getFounderImage(founder) {

      // find any image
      if (founder.FounderMedia && founder.FounderMedia.length > 1) {
        // find featured image or return the first
        let featured = founder.FounderMedia.filter(item => item.featured)[0];

        return featured?.Media?.thumbUrl || founder.FounderMedia[0].Media.thumbUrl;
      }

      // find youtube image if possible
      if (founder.youtubeVideos && founder.youtubeVideos.length > 0) {
        return `https://img.youtube.com/vi/${founder?.youtubeVideos?.[0]?.youtubeId}/hqdefault.jpg`;
      }


      // we can not get any image
      return false;
    },
  },
  serverPrefetch: async function serverPrefetch() {
    return await this.getSSRPrefetchPromise();
  },
};
</script>

<style scoped lang="scss">
.sidebar-inner {
  display: flex;
  flex-direction: column;
  height: 100%;

  .illustration {
    display: flex;
    margin: 0 auto;
    align-self: flex-end;
    margin-top: auto;
    margin-inline: auto;
    height: auto;
    width: 100%;
    max-height: 28vh;

    img {
      margin-inline: auto;
    }
  }
}

.founder-intro-link {
  display: contents;
  text-decoration: none;
  color: inherit;
}
.founder-modal-content {
  position: relative;
  padding-top: var(--margin-2xl) !important;
}

.founder-modal-timer-container {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  width: calc(var(--base-margin) * 300);
  max-width: calc(100% - (var(--base-margin) * 90));
  inset-inline-start: 50%;
  transform: translateX(50%);
  border-radius: 0 0 calc(var(--base-margin) * 30) calc(var(--base-margin) * 30);
  border: 1px solid var(--c-bg-1);
  box-shadow: 0 0 calc(var(--base-margin) * 12) 1px rgba(255, 255, 255, 0.2);
  z-index: var(--z-2);
  padding: var(--margin-s) var(--margin-m);
  background-color: var(--c-bg-2);
  color: var(--c-lead);

  [dir="ltr"] & {
    transform: translateX(-50%);
  }

  @media (max-width: 500px) {
    inset-inline-start: 0;
    transform: none;
    max-width: calc(100% - (var(--base-margin) * 50));
    border-radius: 0 0 0 calc(var(--base-margin) * 30);

    [dir="ltr"] & {
      border-radius: 0 0 calc(var(--base-margin) * 30) 0;
    }
  }
}

.founder-board :deep(.modal__body) {
  //border: 3px solid red !important;
}

.edit-ui {
  z-index: var(--z-2);
  top: 0;
  inset-inline-start: 0;
  border-radius: 0 0 0 calc(var(--base-margin) * 40);
}

</style>

<style lang="scss">
.founder-full-modal {
  .modal__inner {
    overflow: hidden !important;
  }
}

founder-board .sidebar-inner .search-input {
  .field__element {
    min-width: calc(100 * var(--base-margin));
    @media (max-width: 400px) {
      width: 100%;
      // min-width: calc(var(--base-margin) * 100) !important;
    }
  }
}
</style>
